import axios from "axios";
import apiURI from "./Api";

export default class ThemeService {
  async getThemeByUser(token) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/themes/getThemeByUser`,
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  }

  async getThemeByUserPublic(username) {
    const response = await axios({
      method: "get",
      url: `${apiURI}/themes/getThemeByUserPublic/${username}`,
    });
    return response.data;
  }

  async createTheme(token, payload) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/themes/create`,
      data: payload,
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  }

  async updateThemeByUser(token, payload) {
    const response = await axios({
      method: "post",
      url: `${apiURI}/themes/updateThemeByUser`,
      data: payload,
      headers: { Authorization: "Bearer " + token },
    });
    return response.data;
  }
}
